export function getAppointmentsPath() {
  return '/termine'
}
